export default __webpack_public_path__ + "static/media/thrash.eaaae115.svg";